import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import campaignTemplate from './campaign.pug';

export class CampaignColumn extends CampaignuiBaseColumn {
  constructor({
    i18n,
    scope,
    routeTemplate,
    showExperiment,
    name,
    isForVNext,
  }) {
    super({
      name: _.isString(name) ? name : 'Campaign',
      property: _.compact([
        'Campaign/Name',
        'Campaign/Id',
        showExperiment && 'Campaign/BaseCampaignName',
      ]),
      title: i18n.getString('ColumnName_Campaign'),
      sortable: 'Campaign/Name',
      type: 'string',
      bodyClasses: ['grid-column-Campaign'],
    });

    this.i18n = i18n;
    this.scope = scope;
    this.routeTemplate = routeTemplate;
    this.isForVNext = isForVNext;
  }

  pickProperty(item) {
    const { customerId: cid, accountId: aid } = this.scope;
    const {
      Campaign: {
        Name: name,
        Id: cmpid,
        BaseCampaignName: baseCampaignName,
      } = {},
    } = item;

    let ariaLabel = this.i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: name });
    let className = '';

    if (this.isForVNext && baseCampaignName) {
      ariaLabel = this.i18n.getString('Click to scope to experiment {{experimentName}}', { experimentName: name });
      className = 'experiment-name';
    }

    return {
      name,
      href: this.routeTemplate({
        cid,
        aid,
        cmpid,
      }),
      cmpid,
      baseCampaignName,
      isForVNext: this.isForVNext,
      ariaLabel,
      className,
    };
  }

  get template() { return campaignTemplate; }
}

export function createCustomCampaignColumnClass({ name }) {
  return class CustomCampaignColumn extends CampaignColumn {
    constructor({
      i18n,
      scope,
      routeTemplate,
      showExperiment,
      isForVNext,
    }) {
      super({
        i18n,
        scope,
        routeTemplate,
        showExperiment,
        name,
        isForVNext,
      });
    }
  };
}
